import axiosInstance from "./axiosInstance";
import ENDPOINTS from "./endpoints";

export const getRedirectLink = async (payload) => {
  try {
    const response = await axiosInstance.post(
      ENDPOINTS.REDIRECT_URL,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching redirect link:", error);
    throw error;
  }
};

export const getStoreInfo=async(payload)=>{
  try {
    const response = await axiosInstance.post(ENDPOINTS.STORE_INFO, payload);
    return response.data
  } catch (error) {
    console.error("Error fetching Store Info:", error);
    throw error;
  }
}